export default '3.0.0-beta.2';



// WEBPACK FOOTER //
// ./src/lib/version.js